<template>
  <v-container fluid :class="['corporate-vendor-detail-modal', {'fullscreen': $vuetify.breakpoint.smAndDown}]">
    <HkiaraceCardDisplayFrame :is-default-order-sm="true"
                              is-blur-background
                              :image-src="HOST + 'static/' + ($localeGet(vendor, 'icon'))">
      <template #sub-title>

      </template>
      <template #title>
        <span>{{ $localeGet(vendor, 'name') }}</span>
      </template>
      <template #content>
        <div class="corporate-vendor-detail-content-wrapper">
          <div class="corporate-vendor-detail-content"
               v-html="$localeGet(vendor, 'content')">

          </div>
          <div class="corporate-vendor-detail-content-footer">
            <v-btn color="primary"
                   block
                   v-if="$vuetify.breakpoint.mdAndUp"
                   @click="view">GO
            </v-btn>
          </div>
        </div>
      </template>
    </HkiaraceCardDisplayFrame>
    <v-btn color="primary"
           block
           v-if="$vuetify.breakpoint.smAndDown"
           @click="view">GO
    </v-btn>
  </v-container>
</template>

<script>
import HkiaraceCardDisplayFrame from "@/components/HkiaraceCardDisplayFrame";
import {HOST} from "@/main";

export default {
  name: 'CorporateVendorDetailModal',
  components: {HkiaraceCardDisplayFrame},
  props: {
    vendor: Object,
  },
  setup(props, {root, emit}) {
    const view = function () {
      root.$callAPI('hkiarace/corporate_vendor/view/', {id: props.vendor.id}, function (response) {
        let url = response.body.url;
        url = url.match(/^https?:/) ? url : '//' + url;
        window.open(url, '_blank');
      });
    }

    return {
      HOST,
      view,
    }
  },
}
</script>

<style lang="less">
.corporate-vendor-detail-modal {
  background-color: white;
  height: 75vh;

  &.fullscreen {
    height: 100vh !important;
    display: flex;
    flex-direction: column;
  }

  .card-display-container {
    height: 100%;
  }

  .corporate-vendor-detail-content-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    .corporate-vendor-detail-content {
      flex: 1 1 0;
      overflow: auto;
    }

    .corporate-vendor-detail-content-footer {
      padding-top: 8px;
      flex: 0 0 auto;
    }
  }
}
</style>
